<div style="display:flex; flex-direction:row; flex-grow:1; overflow:hidden;">
  <div style="display:flex; flex-direction:column; flex:1; overflow:hidden;">
    <student-notes style="height: 100%;;height: -webkit-fill-available; min-height: -moz-available; position: fixed; width: 100%; padding-bottom: 50px;"></student-notes>
  </div>
</div>